import React from 'react';
import styled from 'styled-components';
import { FaFileUpload, FaUserMd, FaCheck, FaDownload } from 'react-icons/fa';

const TrackerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  margin: 2.5rem auto;
  max-width: 600px;

  &::before {
    content: '';
    position: absolute;
    top: 22px; /* Vertically center with the icons */
    left: 15%;
    right: 15%;
    height: 4px;
    background-color: #e0e0e0;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 22px;
    left: 15%;
    width: ${({ $progress }) => $progress}%;
    height: 4px;
    background-color: #28a745;
    transition: width 0.4s ease-in-out;
    z-index: 1;
  }
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 120px; /* Give a fixed width to prevent text wrapping from pushing things around */
  position: relative;
  z-index: 2;
`;

const IconWrapper = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.75rem;
  background-color: ${({ $active, $completed }) => ($completed ? '#28a745' : $active ? '#005eb8' : '#e0e0e0')};
  color: white;
  border: 4px solid #ffffff; /* Same as card background */
  transition: background-color 0.3s;

  svg {
    font-size: 1.2rem;
  }
`;

const StepLabel = styled.div`
  font-weight: ${({ $active }) => ($active ? 'bold' : 'normal')};
  color: ${({ $active, $completed }) => ($active || $completed ? '#333' : '#666')};
  font-size: 0.9rem;
  line-height: 1.3;
`;

const OrderStatusTracker = ({ status }) => {
  const steps = [
    { id: 'awaiting_submission', label: 'Upload Documents', icon: <FaFileUpload /> },
    { id: 'submitted', label: 'Doctor Reviewing', icon: <FaUserMd /> },
    { id: 'completed', label: 'Letter Ready', icon: <FaDownload /> },
  ];

  // Normalize statuses that belong to the 'submitted' phase
  const normalizedStatus = ['ai_draft_generated', 'ai_failed'].includes(status) ? 'submitted' : status;

  const currentStepIndex = steps.findIndex(step => step.id === normalizedStatus);
  // Calculate progress for the green bar. If no step is found, default to 0.
  // The progress bar should only cover the gaps, so we multiply by 70% of the container width.
  const progressPercentage = currentStepIndex > 0 ? (currentStepIndex / (steps.length - 1)) * 70 : 0;

  return (
    <TrackerContainer $progress={progressPercentage}>
      {steps.map((step, index) => {
        const isCompleted = currentStepIndex > index;
        const isActive = currentStepIndex === index;
        return (
          <Step key={step.id}>
            <IconWrapper $active={isActive} $completed={isCompleted}>
              {isCompleted ? <FaCheck /> : step.icon}
            </IconWrapper>
            <StepLabel $active={isActive} $completed={isCompleted}>{step.label}</StepLabel>
          </Step>
        );
      })}
    </TrackerContainer>
  );
};

export default OrderStatusTracker;